// Import dependencies
import { initialiser } from '../../ramen-imports/utilitybelt';

class DriverCard {
  constructor(config) {
    const { el } = config;

    // Set module dom elements
    this.container = el;
    this.aTag = this.container.querySelector('.js-card--driver a');
  }

  init = () => {
    this.aTag.addEventListener('click', this.handleClick);
    this.aTag.addEventListener('touchstart', this.handleClick);
  };

  handleClick = (e) => {
    e.preventDefault();
    this.aTag.classList.toggle('c-card--driver-active');
    setTimeout(() => {
      window.location = this.aTag.getAttribute('href');
    }, 200);
  };
}

export default (settings) => initialiser(settings, DriverCard);
